export default __webpack_public_path__ + "static/media/shopify-icon.5ea9ee76.svg";